import type { SVGProps } from "react";
const SvgCommunityPostTypeMilestone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 15"
    fontSize="1rem"
    {...props}
  >
    <g clipPath="url(#community-post-type-milestone_svg__a)">
      <path
        fill="#E893C7"
        d="M11.603 4.412a.46.46 0 0 1-.22.397L5.558 8.206v5.47h.882c.22 0 .441.221.441.442 0 .264-.22.44-.44.44H3.793c-.264 0-.441-.176-.441-.44 0-.22.176-.441.441-.441h.883V.882c0-.176.132-.308.22-.397 0-.044.353-.088.441 0h.044l6 3.53c.133.088.221.264.221.397"
      />
    </g>
    <defs>
      <clipPath id="community-post-type-milestone_svg__a">
        <path fill="#fff" d="M0 0h15v15H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCommunityPostTypeMilestone;
